/* BHALLO — nas paginas de colecao (Catalogo), joga os ESGOTADOS pro fim.
   Produto disponivel na frente, esgotado atras (mantendo a ordem relativa).
   So roda em /collections/... — a home fica com a ordem manual que voce definiu. */
(function () {
  function esgotado(li) {
    var b = li.querySelector('.badge');
    if (b && /esgotad|sold\s*out/i.test(b.textContent || '')) return true;
    var btn = li.querySelector('.quick-add__submit, .product-form__submit');
    if (btn && btn.disabled) return true;
    return false;
  }

  function reordenar() {
    if (!/^\/collections\//.test(window.location.pathname)) return;

    var grids = document.querySelectorAll('.product-grid');
    for (var g = 0; g < grids.length; g++) {
      var grid = grids[g];
      var itens = [];
      for (var i = 0; i < grid.children.length; i++) {
        if (grid.children[i].tagName === 'LI') itens.push(grid.children[i]);
      }
      if (itens.length < 2) continue;

      var disponiveis = [], fora = [];
      itens.forEach(function (li) { (esgotado(li) ? fora : disponiveis).push(li); });

      // nada a fazer se e tudo disponivel ou tudo esgotado
      if (!fora.length || !disponiveis.length) continue;

      // reanexa na ordem: disponiveis primeiro, esgotados depois
      disponiveis.concat(fora).forEach(function (li) { grid.appendChild(li); });
    }
  }

  if (document.readyState !== 'loading') reordenar();
  else document.addEventListener('DOMContentLoaded', reordenar);
})();
